var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.444 20L20 35L35.556 20C38.256 17.967 40 14.744 40 11.111C40 4.978 35.022 0 28.889 0C25.256 0 22.022 1.756 20 4.456C17.978 1.756 14.744 0 11.111 0C4.978 0 0 4.978 0 11.111C0 14.744 1.744 17.967 4.444 20ZM11.111 2C13.961 2 16.685 3.366 18.399 5.654L20 7.792L21.601 5.655C23.315 3.366 26.039 2 28.889 2C33.913 2 38 6.087 38 11.111C38 13.999 36.671 16.657 34.352 18.402L34.255 18.475L34.167 18.56L20 32.222L5.833 18.56L5.745 18.475L5.648 18.402C3.33 16.657 2 13.999 2 11.111C2 6.087 6.087 2 11.111 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.dfe29d34a35a32d8e997e05711c01c1e.svg";
export { ForwardRef as ReactComponent };